export const ASC_ORDERS = 'asc-orders';
export const IN_PROGRESS = 'in-progress';
export const EXTERNAL = 'external';
export const ARCHIVED = 'archived';
export const CLAIMS = 'claims';

export type ORDERS_TAB = typeof IN_PROGRESS | typeof ASC_ORDERS | typeof EXTERNAL | typeof ARCHIVED | typeof CLAIMS;
